module.exports = __webpack_public_path__ + "img/dj.4d65966c.svg";